var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M431 167.901L284.974 103L81 194.556V316.245L284.974 408.96L431 344.06V167.901Z",
    fill: "#3B82F6",
    stroke: "#3B82F6",
    strokeWidth: 1.06236
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.338 305.815V206.146L121.563 215.417V296.543L105.338 305.815Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.834 317.404V194.556L144.742 203.828V308.133L130.834 317.404Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.172 326.676L154.013 184.126L169.079 193.397V317.404L155.172 326.676Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.51 338.265V171.378L194.576 184.126L193.417 330.152L179.51 338.265Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.689 348.696V162.106L216.596 171.378V338.265L202.689 348.696Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M228.185 359.126L227.027 150.517L242.093 160.947V349.854L228.185 359.126Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M251.364 370.715V141.245L265.272 148.199V361.444L251.364 370.715Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290.768 376.51V134.292L400.868 184.126V227.007H374.212V203.828L320.901 179.49L319.742 330.152L374.212 308.133V268.729L346.397 269.888V242.073H400.868L403.185 326.676L290.768 376.51Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.338 305.815V206.146L121.563 215.417V296.543L105.338 305.815Z",
    stroke: "white",
    strokeWidth: 1.06236
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.834 317.404V194.556L144.742 203.828V308.133L130.834 317.404Z",
    stroke: "white",
    strokeWidth: 1.06236
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.172 326.676L154.013 184.126L169.079 193.397V317.404L155.172 326.676Z",
    stroke: "white",
    strokeWidth: 1.06236
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.51 338.265V171.378L194.576 184.126L193.417 330.152L179.51 338.265Z",
    stroke: "white",
    strokeWidth: 1.06236
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M202.689 348.696V162.106L216.596 171.378V338.265L202.689 348.696Z",
    stroke: "white",
    strokeWidth: 1.06236
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M228.185 359.126L227.027 150.517L242.093 160.947V349.854L228.185 359.126Z",
    stroke: "white",
    strokeWidth: 1.06236
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M251.364 370.715V141.245L265.272 148.199V361.444L251.364 370.715Z",
    stroke: "white",
    strokeWidth: 1.06236
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M290.768 376.51V134.292L400.868 184.126V227.007H374.212V203.828L320.901 179.49L319.742 330.152L374.212 308.133V268.729L346.397 269.888V242.073H400.868L403.185 326.676L290.768 376.51Z",
    stroke: "white",
    strokeWidth: 1.06236
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame 2.137aa6b91130da1d04c825528030f1e9.svg";
export { ForwardRef as ReactComponent };